import { orderService } from "@/api/order.service.js";

export const state = {
  orders: [],
  selectedOrder: {}
}

export const actions = {
  getOrders({ commit }) {
    orderService.getOrders()
      .then(response => {
        commit("setOrders", response);
        commit(
          'navigation/breadcrumbAdded',
          {
            text: 'Orders',
            level: 1,
            to: `/orders`,
            active: false
          },
          { root: true }
        );
      }
    )
  },
  getOrderById({ commit }, id) {
    return orderService.getOrderById(id)
      .then(response => {
        commit("setSelectedOrder", response);
        commit(
          'navigation/breadcrumbAdded',
          {
            text: 'Orders',
            level: 1,
            to: `/orders`,
            active: false
          },
          { root: true }
        );
        commit(
          'navigation/breadcrumbAdded',
          {
            text: response.wh_id,
            level: 2,
            to: `/orders/${response.id}`,
            active: true
          },
          { root: true }
        );
      })
  }
};

export const mutations = {
  setOrders(state, orders) {
    state.orders = orders;
  },
  setSelectedOrder(state, order) {
    state.selectedOrder = order;
  }
};
